import React from "react";

interface IconProps extends React.SVGProps<SVGSVGElement> {}

export const MaterialIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props} // allows passing className, onClick, etc.
    >
      <path
        d="M4.16667 16.6836C3.70833 16.6836 3.31597 16.5204 2.98958 16.194C2.66319 15.8676 2.5 15.4753 2.5 15.0169V5.01693C2.5 4.55859 2.66319 4.16623 2.98958 3.83984C3.31597 3.51345 3.70833 3.35026 4.16667 3.35026H7.5V5.01693H4.16667V15.0169H7.5V16.6836H4.16667ZM9.16667 18.3503V1.68359H10.8333V3.35026H15.8333C16.2917 3.35026 16.684 3.51345 17.0104 3.83984C17.3368 4.16623 17.5 4.55859 17.5 5.01693V15.0169C17.5 15.4753 17.3368 15.8676 17.0104 16.194C16.684 16.5204 16.2917 16.6836 15.8333 16.6836H10.8333V18.3503H9.16667ZM10.8333 15.0169H15.8333V5.01693H10.8333V15.0169Z"
        fill="currentColor"
      />
    </svg>
  );
};
